import { profileTabs, profileTypeEndPoint, profileTypeEnum } from "@components/templates/Profile/ProfileHeader/profile-enum";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { transformData } from "@helpers/profileHelper";
import { toast } from "react-toastify";
import ProfileHeader from "@components/templates/Profile/ProfileHeader";
import { useDispatch, useSelector } from "react-redux";
import { profileType } from "@utils/enum";
import { isFreightForwarderHandler, profileRedirectionIdHandler, tabDetailsHandler } from "@redux/LogisticsProfile/logisticsProfileSlice";

const Header = () => {
  const { companyId } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [profileDetails, setProfileDetails] = useState({});
  const [copyText, setCopyText] = useState([]);
  const [profileName, setProfileName] = useState("VOCC");
  const [profileId, setProfileId] = useState(null);
  const dispatch = useDispatch();
  const { tabDetails } = useSelector((state) => state.logisticsProfile);

  const generateCopyTextArr = (data) => {
    return [
      { key: "SCAC Code", label: transformData(data.scac_code, false, false), isCopy: false },
      { key: "SIC Code", label: transformData(data.sic_code, false, false), isCopy: true },
      { key: "Stock Ticker", label: transformData(data.stock_ticker, false, true), isCopy: false },
      { key: "Revenue", label: transformData(data.revenue, false, false), isCopy: false },
    ].filter((item) => item.label);
  };

  useEffect(() => {
    const requestPayload = {
      profile_type: profileTypeEnum.logistics,
      _id: companyId,
    };
    axios
      .post(profileTypeEndPoint.logistics.getProfileHeaderDetails, requestPayload)
      .then((res) => {
        const { status, data } = res.data;
        if (status === "success" && data) {
          setLoading(false);
          const transFormResponse = {
            ...data,
            name: transformData(data.name, true, false),
            state: transformData(data.state, true, false),
            country: transformData(data.country, true, false),
            countryCode: transformData(data.country_code, false, true),
            address: transformData(data.address, true, false),
            is_nvocc: data?.is_nvocc || false,
          };
          setProfileId(data?.elastic_data_id?.[0]);
          setProfileDetails(transFormResponse);
          setCopyText(generateCopyTextArr(data));
          const { elastic_data_id } = data;
          dispatch(profileRedirectionIdHandler(elastic_data_id?.[0]));
          dispatch(isFreightForwarderHandler(data?.is_freight_forwarder));
        } else {
          throw new Error("");
        }
      })
      .catch(() => {
        setError(true);
        setLoading(false);
        toast.error("Something went wrong. Please try again later !!!");
      });
  }, [companyId]);

  useEffect(() => {
    const profileName = new URLSearchParams(location.search).get("profileName");
    const isLogisticsProfile = profileTabs.find((item) => item.redirectionEnum === profileName);
    dispatch(
      tabDetailsHandler({
        ...tabDetails,
        activePanelId: isLogisticsProfile ? isLogisticsProfile.id : "",
      })
    );
    setProfileName(isLogisticsProfile ? isLogisticsProfile.text : "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <ProfileHeader profileId={profileId} profileType={profileType.logistics} loading={loading} error={error} profileDetails={profileDetails} copyText={copyText} copyTextPill={[]} showProfilePill={profileName} showFavourites={true} />;
};

export default Header;
